import { AutoMap } from "@automapper/classes"
import { Temporal } from "@js-temporal/polyfill"
import { IAppareil } from "../iappareil"
import { PrelevementGenerateurDialyse } from "./prelevement-generateur-dialyse"
import { ETaskStatus } from "src/app/models/enums/task-status"
import { BaseDOM } from "../base.dom"

export class Generateur extends BaseDOM<Generateur> implements IAppareil {
    @AutoMap()
    Code: string = ''
    @AutoMap()
    TaskStatus: ETaskStatus = ETaskStatus.New
    @AutoMap()
    ZoneSalle: string = ''
    @AutoMap()
    SamplingDate?: Temporal.PlainDateTime;
    @AutoMap()
    Marque: string = ''
    @AutoMap()
    Modele: string = ''
    @AutoMap()
    NumSerie: string = ''
    @AutoMap()
    NumAppareil: string = ''
    @AutoMap(() => [PrelevementGenerateurDialyse])
    PrelevementGenerateurDialyseList: PrelevementGenerateurDialyse[] = [];

}